import { Box, Button, TextField, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent, Select, MenuItem, useMediaQuery, InputLabel, Typography, useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../global/Header";
import { SelectChangeEvent } from "@mui/material";
import React from 'react'
import { useState } from "react";
import { tokens } from "../../../theme"
import { useParams, Link } from "react-router-dom"
import { useGetUsersQuery } from "../../../features/users/usersApiSlice";
import PulseLoader from "react-spinners/PulseLoader";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useDeleteOrganizationMutation, useGetOrganizationsQuery, useUpdateOrganizationMutation, useGetOrganizationByOrganizationIdQuery } from "../../../features/organizations/organizationsApiSlice";


//go back for email validation
const organizationSchema = yup.object().shape({
    name: yup.string().required("Required"),
    email: yup.string(),
    address: yup.string(),
    phone: yup.string()
})




const OrganizationEditForm = () => {
    const navigate = useNavigate();
    const { isAdmin } = useAuth();
    const { organization_id } = useParams();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [open, setOpen] = React.useState(false);

    // Fetch a single organization by its organization_id
    const {
        data: organization,
        isLoading: isOrgLoading,
        isError: isOrgError,
        error: orgError,
    } = useGetOrganizationByOrganizationIdQuery(organization_id);

    console.log("organization", organization)

    const [updateOrganization] = useUpdateOrganizationMutation();
    const [deleteOrganization] = useDeleteOrganizationMutation();

    const formats = ["Parquet", "CSV"];

    // Initialize state with default values
    const [adc_selected, setAdcSelected] = useState("False");
    const [ldc_selected, setLdcSelected] = useState("False");
    const [bito_hem_selected, setBitoHemEnabledSelected] = useState("False");
    const [auction_selected, setAuctionSelected] = useState("False");
    const [delivery_format, setDeliveryFormat] = useState([]);
    const [beeswax_cookie_sync_selected, setBeeswaxCookieSyncSelected] = useState("False");

    // Ensure proper media query handling
    const isNonMobile = useMediaQuery("(min-width:600px)");

    // Effect to update state once `organization` data is available
    React.useEffect(() => {
        if (organization) {
            setAdcSelected(organization.adc_enabled ? "True" : "False");
            setLdcSelected(organization.ldc_enabled ? "True" : "False");
            setBitoHemEnabledSelected(organization.bito_hem_enabled ? "True" : "False");
            setAuctionSelected(organization.auction_enabled ? "True" : "False");
            setBeeswaxCookieSyncSelected(organization.beeswax_cookie_sync ? "True" : "False");
            setDeliveryFormat(
                Array.isArray(organization.delivery_format)
                    ? organization.delivery_format
                    : [organization.delivery_format || formats[0]]
            );
        }
    }, [organization]); // Dependency ensures this runs only when `organization` changes

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleFormatChange = (event) => {
        setDeliveryFormat(event.target.value);
    };

    // Handler functions for the Select components
    const selectionAdcChangeHandler = (event) => {
        setAdcSelected(event.target.value);
    };

    const selectionBeeswaxCookieSyncChangeHandler = (event) => {
        setBeeswaxCookieSyncSelected(event.target.value);
    };

    const selectionAuctionChangeHandler = (event) => {
        setAuctionSelected(event.target.value);
    };

    const selectionBitoHemEnabledChangeHandler = (event) => {
        setBitoHemEnabledSelected(event.target.value);
    };

    const selectionLdcChangeHandler = (event) => {
        setLdcSelected(event.target.value);
    };

    const onDeleteOrganizationClicked = async () => {
        try {
            await deleteOrganization({ id: organization._id });
            navigate("/console/organizations");
            handleClose();
        } catch (err) {
            console.error("Error deleting organization:", err);
        }
    };

    const onSaveOrganizationClicked = async (values) => {
        const updatedOrganization = {
            id: organization._id,
            name: values.name,
            address: values.address,
            phone: values.phone,
            s3_uri: values.s3_uri,
            storage_integration: values.storage_integration,
            pid: values.pid,
            adc_enabled: adc_selected === "True",
            ldc_enabled: ldc_selected === "True",
            auction_enabled: auction_selected === "True",
            beeswax_cookie_sync: beeswax_cookie_sync_selected === "True",
            bito_hem_enabled: bito_hem_selected === "True",
            email: values.email,
            delivery_format: delivery_format,
            aws_account_id: values.aws_account_id,
        };

        try {
            await updateOrganization(updatedOrganization);
            navigate("/console/organizations");
        } catch (err) {
            console.error("Error updating organization:", err);
        }
    };

    // Show loading spinner
    if (isOrgLoading) {
        return <PulseLoader color={"#FFF"} />;
    }

    // Show error message
    if (isOrgError || !organization) {
        return <p className="errmsg">{orgError?.data?.message || "Organization not found."}</p>;
    }

    // Prepare initial values for the form
    const initialValues = {
        name: organization.name || "",
        pid: organization.pid || "",
        email: organization.email || "",
        phone: organization.phone || "",
        address: organization.address || "",
        adc_enabled: organization.adc_enabled || false,
        ldc_enabled: organization.ldc_enabled || false,
        auction_enabled: organization.auction_enabled || false,
        bito_hem_enabled: organization.bito_hem_enabled || false,
        beeswax_cookie_sync: organization.beeswax_cookie_sync || false,
        delivery_format: organization.delivery_format || formats[0],
    };


    return (
        <Box
            m="20px">
            <Header title={`EDIT ORGANIZATION`} subtitle="Edit the organization fields below" />

            <Formik
                onSubmit={onSaveOrganizationClicked}
                initialValues={initialValues}
                validationSchema={organizationSchema}>
                {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Box
                            display="grid"
                            gap="30px"
                            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                            }}
                        >
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.name}
                                name="name"
                                error={!!touched.name && !!errors.name}
                                helperText={touched.name && errors.name}
                                sx={{ gridColumn: "span 2" }}
                            />
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Email"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.email}
                                name="email"
                                error={!!touched.email && !!errors.email}
                                helperText={touched.email && errors.email}
                                sx={{ gridColumn: "span 2" }}
                            />
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Phone"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.phone}
                                name="phone"
                                error={!!touched.phone && !!errors.phone}
                                helperText={touched.phone && errors.phone}
                                sx={{ gridColumn: "span 2" }}
                            />
                            {isAdmin === true &&
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="PID:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.pid}
                                    name="pid"
                                    error={!!touched.pid && !!errors.pid}
                                    helperText={touched.pid && errors.pid}
                                    sx={{ gridColumn: "span 2" }}
                                />
                            }
                            {isAdmin === true && (
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="AWS Account ID/Provisioned User ARN"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.aws_account_id}
                                    name="aws_account_id"
                                    error={!!touched.aws_account_id && !!errors.aws_account_id}
                                    helperText={touched.aws_account_id && errors.aws_account_id}
                                    sx={{ gridColumn: "span 2" }}
                                />
                            )}
                            {isAdmin === true &&
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="S3 URI:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.s3_uri}
                                    name="s3_uri"
                                    error={!!touched.s3_uri && !!errors.s3_uri}
                                    helperText={touched.s3_uri && errors.s3_uri}
                                    sx={{ gridColumn: "span 2" }}
                                />
                            }
                            {isAdmin === true &&
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Storage Integration:"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.storage_integration}
                                    name="storage_integration"
                                    error={!!touched.storage_integration && !!errors.storage_integration}
                                    helperText={touched.storage_integration && errors.storage_integration}
                                    sx={{ gridColumn: "span 2" }}
                                />
                            }
                            {isAdmin === true &&
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography
                                        variant="h6"
                                        color={colors.grey[300]}
                                        sx={{ m: "15px 0 5px 20px" }}
                                    >
                                        Delivery Format:
                                    </Typography>
                                    <Select
                                        fullWidth
                                        id="delivery_format"
                                        name="delivery_format"
                                        multiple
                                        label="Delivery Format:"
                                        value={delivery_format}
                                        onChange={handleFormatChange}
                                        sx={{ minWidth: '50%' }}
                                    >
                                        {formats.map((format) => (
                                            <MenuItem
                                                key={format}
                                                value={format}
                                            >
                                                {format}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            }

                            {isAdmin === true && (
                                <Box
                                    display="grid"
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    gridColumn="span 4"
                                    sx={{
                                        "& > div": { gridColumn: "span 1" },
                                    }}
                                >
                                    <Box mr={2}>
                                        <Typography
                                            variant="h6"
                                            color={colors.grey[300]}
                                            sx={{ m: "15px 0 5px 20px" }}
                                        >
                                            ADC Enabled (Use ADC Onboarder!)::
                                        </Typography>
                                        <Select
                                            fullWidth
                                            id="adc_enabled"
                                            name="adc_enabled"
                                            label="ADC Enabled (USE ADC Onboarder!!!):"
                                            value={adc_selected}
                                            onChange={selectionAdcChangeHandler}
                                            disabled={true}
                                        >
                                            <MenuItem value="True">True</MenuItem>
                                            <MenuItem value="False">False</MenuItem>
                                        </Select>
                                    </Box>
                                    <Box mr={2}>
                                        <Typography
                                            variant="h6"
                                            color={colors.grey[300]}
                                            sx={{ m: "15px 0 5px 20px" }}
                                        >
                                            Beeswax Cookie Sync:
                                        </Typography>
                                        <Select
                                            fullWidth
                                            id="beeswax_cookie_sync"
                                            name="beeswax_cookie_sync"
                                            label="Beeswax Cookie Sync:"
                                            value={beeswax_cookie_sync_selected}
                                            onChange={selectionBeeswaxCookieSyncChangeHandler}
                                        >
                                            <MenuItem value="True">True</MenuItem>
                                            <MenuItem value="False">False</MenuItem>
                                        </Select>
                                    </Box>
                                    <Box mr={2}>
                                        <Typography
                                            variant="h6"
                                            color={colors.grey[300]}
                                            sx={{ m: "15px 0 5px 20px" }}
                                        >
                                            Auction Enabled:
                                        </Typography>
                                        <Select
                                            fullWidth
                                            id="auction_enabled"
                                            name="auction_enabled"
                                            label="Auction Enabled:"
                                            value={auction_selected}
                                            onChange={selectionAuctionChangeHandler}
                                        >
                                            <MenuItem value="True">True</MenuItem>
                                            <MenuItem value="False">False</MenuItem>
                                        </Select>
                                    </Box>
                                    <Box mr={2}>
                                        <Typography
                                            variant="h6"
                                            color={colors.grey[300]}
                                            sx={{ m: "15px 0 5px 20px" }}
                                        >
                                            Bito HEM Enabled:
                                        </Typography>
                                        <Select
                                            fullWidth
                                            id="bito_hem_enabled"
                                            name="bito_hem_enabled"
                                            label="Bito HEM Table DeliveryEnabled:"
                                            value={bito_hem_selected}
                                            onChange={selectionBitoHemEnabledChangeHandler}
                                        >
                                            <MenuItem value="True">True</MenuItem>
                                            <MenuItem value="False">False</MenuItem>
                                        </Select>
                                    </Box>
                                    <Box mr={2}>
                                        <Typography
                                            variant="h6"
                                            color={colors.grey[300]}
                                            sx={{ m: "15px 0 5px 20px" }}
                                        >
                                            LDC Enabled:
                                        </Typography>
                                        <Select
                                            fullWidth
                                            id="ldc_enabled"
                                            name="ldc_enabled"
                                            label="LDC Enabled:"
                                            value={ldc_selected}
                                            onChange={selectionLdcChangeHandler}
                                        >
                                            <MenuItem value="True">True</MenuItem>
                                            <MenuItem value="False">False</MenuItem>
                                        </Select>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                        <Box display="flex" justifyContent="end" mt="20px">
                            <Button type="submit" color="secondary" variant="contained">
                                Save Organization
                            </Button>
                            <Link to="/console" color="secondary" variant="contained">

                            </Link>
                        </Box>
                    </form>
                )}
            </Formik>
            <Box>
                <Button display="flex" onClick={handleClickOpen} justifyContent="space-between" variant="contained" >Delete Organization</Button>
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this organization?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Deleting this organization will permanently remove it from your account.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error">
                        Cancel
                    </Button>
                    <Button onClick={onDeleteOrganizationClicked} color="secondary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}


export default OrganizationEditForm